<div *ngFor="let notification of notifications">
  <edge-notification [data]="notification"></edge-notification>
</div>